<div class="header-margin navbar navbar-expand-lg bg-light mx-0 pb-0 mb-1">
  <div class="navbar-brand me-0">
    <a
      class="header-image"
      routerLink="/"
    >
      <img
        src="https://cms.legalandgeneral.com/globalassets/global-shared-assets/logos/landg_logo.svg"
        height="auto"
        width="80"
        [alt]="logoAltText"
      />
    </a>
  </div>

  <div
    class="collapse navbar-collapse ms-2"
    id="navbarSupportedContent"
  >
    <ul class="nav navbar-nav flex-grow-1 mt-3">
      @for (item of nav; track item) {
        @if (item.subItems) {
          <li
            class="nav-item me-2"
            ngbDropdown
          >
            <div
              routerLinkActive="tab-active"
              class="nav-link"
              ngbDropdownToggle
              [hidden]="item.visible && !item.visible()"
            >
              {{ item.label }}
              <div ngbDropdownMenu>
                @for (subItem of item.subItems; track subItem) {
                  <a
                    ngbDropdownItem
                    [routerLink]="subItem.routerLink"
                    [hidden]="subItem.visible && !subItem.visible()"
                    [attr.data-testid]="'nav_'+subItem.label | slugify:'_'"
                    (click)="subItem.onClick && subItem.onClick()"
                  >
                    {{ subItem.label }}
                  </a>
                }
              </div>
            </div>
          </li>
        } @else {
          <li class="nav-item me-2">
            <a
              class="nav-link"
              routerLinkActive="tab-active"
              [routerLink]="item.routerLink"
              [routerLinkActiveOptions]="{ exact: item.routerLink === '/' }"
              [hidden]="item.visible && !item.visible()"
              [attr.data-testid]="'nav_'+item.label | slugify:'_'"
              (click)="item.onClick && item.onClick()"
            >
              {{ item.label }}
            </a>
          </li>
        }
      }
    </ul>
    <lib-login-menu />
  </div>
</div>
